export const ReportEN = {
    "Title":{
        "reportListPersonnel" : "Report List Personnel",
        "nameReport" : "Name Report",
        "personnelRecord" : "Personnel Record",
        "personnelChange" : "Personnel Change",
        "gender" : "Gender",
        "age" : "Age",
        "academicLevel" : "Academic Level",
        "laborContract" : "Labor Contract",
        "contractType" : "Contract Type",
        "insurance" : "Insurance",
        "monthly" : "Monthly",
        "decision" : "Decision",
        "bonus" : "Bonus",
        "laborDiscipline" : "Labor Discipline",
        "disciplineIsOutstanding" : "Discipline is outstanding",
        "decidedToIncrease" : "Decided to increase the salaries",
        "decisionDepartment" : "The decision to move the department",
        "welfareReport" : "Welfare report",
        "codeNV" : "Code NV",
        "personnel" : "Personnel",
        "department" : "Department",
        "jobPosition" : "JobPosition",
        "jobTitle" : "JobTitle",
        "amountOfMoney" : "Amount of money",
        "dateOfEnjoyment" : "Date of enjoyment",
        "type" : "Type",
        "reasonError": "Reason Error",
        "creatDate" : "Create Date",
        "rangDate" : "Date of violation",
        "money" : "Money infringement",
        "decisionMaker" : "Decision making level",
        "moneyBonus" : "Money bonus",
        "effectiveDate" : "Effective date",
        "disciplinaryDay" : "Disciplinary Day",
        "curDepartment" : " Current Department",
        "curJobPosition" : "Current JobPosition",
        "curJobTitle" : "Current JobTitle",
        "newDepartment" : "New Department",
        "newJobPosition" : "New JobPosition",
        "newJobTitle" : "New JobTitle",
    }
}